import { api } from "../../../utils/api";

export async function getViewInstallments(data) {
    try {
        const response = await api.get(`financial/queue-shipping/${data}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}
